import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { mapToHttpParams } from '@bcl/design-system';
import { environment } from 'src/environments';
import {
  ActionCommentsList,
  ActionPointCommentsFilterModel,
} from './action-comments.model';

@Injectable({ providedIn: 'root' })
export class ActionCommentsService {
  constructor(private readonly http: HttpClient) {}

  public getActionComments(
    filter: ActionPointCommentsFilterModel
  ): Observable<ActionCommentsList> {
    const params: ActionPointCommentsFilterModel = {
      parentID: filter.parentID,
      pageNumber: filter.pageNumber ?? 1,
      pageSize: filter.pageSize ?? 10,
    };

    return this.http.get<ActionCommentsList>(
      `${environment.apiHost}/actionPoints/comment/list`,
      {
        params: mapToHttpParams(
          params as unknown as { [key: string]: unknown }
        ),
      }
    );
  }
}
